import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { FieldsetMUI } from 'components/StyledElements'
import { Stack } from '@mui/material'
import { shallowEqual, useSelector } from 'react-redux'
import MapRoundedIcon from '@mui/icons-material/MapRounded'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import { SeeOtherIconTooltip } from '../SeeIconTooltip'
import { usedUrl } from 'conf/basepath'
import useSandreList from 'utils/customHook/useSandreList'
import { SANDRE } from 'referencial/constants/ReferencialConstants'

const DistributionUnitParameters = ({
    defaultProps,
}) => {
    const {
        qualityThresholds,
    } = useSelector(store => ({
        qualityThresholds: store.QualityReducer.thresholds,
    }), shallowEqual)

    const contributorTypeList = useSandreList(SANDRE.CONTRIBUTOR_TYPES).map(c => ({ ...c, name: `[${c.code}] ${c.name}` }))

    return (
        <FieldsetMUI
            title={(
                <Stack direction='row' alignItems='center' gap={0.5} sx={{ padding: '0 0.5rem' }}>
                    <MapRoundedIcon />
                    {i18n.distributionUnitName}
                </Stack>
            )}
        >
            <Stack spacing={1.25}>
                <ParameterWithSuperMultiAutocomplete
                    {...defaultProps}
                    parameter='UDI_REFERENCE_THRESHOLD'
                    options={qualityThresholds}
                    title={i18n.referenceThresholds}
                    iconTooltip={
                        <SeeOtherIconTooltip
                            title={i18n.seeQualityThresholds}
                            link={`${usedUrl}#/quality/qualityOptions/threshold`}
                        />
                    }
                    keyLabel='name'
                    multiple
                    limit={1}
                />

                <ParameterWithSuperMultiAutocomplete
                    {...defaultProps}
                    parameter='contributorTypeOperator'
                    options={contributorTypeList}
                    title={i18n.operatorTypeContributor}
                    keyValue='code'
                    iconTooltip={
                        <SeeOtherIconTooltip
                            title={i18n.seeContributorsTypes}
                            link={`${usedUrl}#/referencial/lexicons`}
                        />
                    }
                />

                <ParameterWithSuperMultiAutocomplete
                    {...defaultProps}
                    parameter='contributorTypeAdministrator'
                    options={contributorTypeList}
                    title={i18n.managerTypeContributor}
                    keyValue='code'
                    iconTooltip={
                        <SeeOtherIconTooltip
                            title={i18n.seeContributorsTypes}
                            link={`${usedUrl}#/referencial/lexicons`}
                        />
                    }
                />
            </Stack>
        </FieldsetMUI>
    )
}

DistributionUnitParameters.propTypes = {
    defaultProps: PropTypes.shape({}),
}

export default DistributionUnitParameters
